// extracted by mini-css-extract-plugin
export default {"document":"dG3LbPszBcoJRBNt+Dv2nA==","quote":"wZrs4Ez0tL1OX-VzNfYlvA==","layout":"ImLN3UNE4RCd3CAcbr4yuw==","main":"ePDdiYSNDmHLd16wS5gIcA==","DE":"_5RjGJwRD85hhXSHUdsnJzg=="};